<template>
  <div>
    <Master :pageTitle="pageTitle">
      <template #button>
        <NormalButton
          :text="buttonName"
          height="32px"
          width="120px"
          class="text-right"
          @click="dialogInfo.register = true"
        />
        <MasterNotePhraseDialog
          v-model="dialogInfo.register"
          @success="registerSuccess()"
        />
      </template>
      <template #list>
        <div class="notePhraseTable">
          <v-data-table
            :headers="tableHeaders"
            :items="getNotePhraseListFromState()"
            :item-key="itemKey"
            :items-per-page="-1"
            hide-default-footer
            :no-data-text="$t('common.common_not-register')"
            class="rounded-lg"
          >
            <template #[`item.title`]="{ item }">
              <div class="font-weight-bold">{{ item.title || '-' }}</div>
            </template>
            <template #[`item.body`]="{ item }">
              <div class="font-weight-bold">{{ item.body || '-' }}</div>
            </template>
            <template #[`item.sortNumber`]="{ item }">
              <div class="text-center">
                {{ item.sortNumber || '-' }}
              </div>
            </template>
            <template #[`item.editAndDelete`]="{ item }">
              <v-row>
                <v-col cols="6" class="text-center px-0">
                  <WhiteButton
                    text="common.common_edit"
                    height="32px"
                    width="48px"
                    @click.native="edit(item)"
                  />
                </v-col>
                <v-col cols="6" class="text-center px-0">
                  <WhiteButton
                    text="common.input_delete"
                    height="32px"
                    width="48px"
                    @click.native="deleteInfo(item)"
                  />
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </div>
      </template>
    </Master>
    <MasterNotePhraseDialog
      v-model="dialogInfo.edit"
      :notePhraseData="notePhraseData"
      :editMode="true"
      @success="editSuccess()"
    />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import headers from './headers'
import { Master } from '@/components/layouts'
import { MasterNotePhraseDialog } from '@/components/layouts/Dialogs'
import { NormalButton, WhiteButton } from '@/components/items'
export default {
  components: {
    Master,
    MasterNotePhraseDialog,
    NormalButton,
    WhiteButton
  },
  data: () => {
    return {
      pageTitle: 'remarks.remarks_note-phrase-management',
      buttonName: 'remarks.remarks_note-phrase-register',
      notePhraseData: {},
      dialogInfo: {
        register: false,
        edit: false
      },
      headers: headers.headers,
      itemKey: 'notePhraseId',
      editMode: false
    }
  },
  created() {
    this.init()
  },
  computed: {
    tableHeaders() {
      const tmp = this.headers.map((ele) => {
        const params = { ...ele }
        params.text = this.$t(ele.text)
        return params
      })
      return tmp
    }
  },
  methods: {
    ...mapActions('NotePhrase', [
      'getNotePhraseListFromApi',
      'deleteNotePhrase'
    ]),
    ...mapGetters('NotePhrase', ['getNotePhraseListFromState']),

    async init() {
      await this.getNotePhraseListFromApi()
    },
    edit(notePhrase) {
      this.notePhraseData = { ...notePhrase }
      this.dialogInfo.edit = true
    },
    registerSuccess() {
      this.init()
      this.dialogInfo.register = false
    },
    editSuccess() {
      this.init()
      this.dialogInfo.edit = false
    },
    async deleteInfo(notePhrase) {
      const isConfirmed = confirm(
        this.$t('master.note-phrase_confirm-to-delete-note-phrase')
      )
      if (!isConfirmed) {
        return
      }
      notePhrase.id = notePhrase.notePhraseId
      const success = await this.deleteNotePhrase(notePhrase)
      this.init()
      alert(this.$t('common.common_delete-comp'))
    }
  }
}
</script>
<style scoped lang="scss">
.notePhraseTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    border: 1px solid #d8d8d8;
    border-right: 0;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;
    border: 1px solid #d8d8d8;
    border-top: 0;
    border-right: 0;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }
  ::v-deep .v-data-table thead th:first-child {
    border-radius: 10px 0 0 0;
  }
  ::v-deep .v-data-table thead th:last-child {
    border-radius: 0 10px 0 0;
  }
  ::v-deep .v-data-table tr:last-child td:first-child {
    border-radius: 0 0 0 10px;
  }
  ::v-deep .v-data-table tr:last-child td:last-child {
    border-radius: 0 0 10px 0;
  }
}
</style>
